import { render } from "./EditSalaryComponent.vue?vue&type=template&id=1ce8046c&scoped=true"
import script from "./EditSalaryComponent.vue?vue&type=script&lang=js"
export * from "./EditSalaryComponent.vue?vue&type=script&lang=js"

import "./EditSalaryComponent.vue?vue&type=style&index=0&id=1ce8046c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce8046c"]])

export default __exports__